import React, { Component, useEffect, useState } from "react";
import Slider from "./components/NetflixSlider";
import Axios from "axios";
import { Link } from "react-router-dom";
import { Avatar, Carousel } from "antd";
import { HeartTwoTone } from "@ant-design/icons";
import "./Home.scss";
import bg1 from './bg1.png';    
import bg2 from './bg2.png';


const Home = () => {
  const [movieList, setMovieList] = useState(null);
  const [gameList, setGameList] = useState(null);
 

  useEffect(() => {
    Axios.get("https://backendexample.sanbersy.com/api/data-movie")
      .then((response) => {        
        setMovieList(response.data);
        return Axios.get("https://backendexample.sanbersy.com/api/data-game");
      })
      .then((response) => {        
        setGameList(response.data);
      })
      .catch((err) => {        
      });
  }, []);

  return (
    <div className="app" style={{ minHeight: "100vh" }}>
      <div>
        <h1>Life Santuy</h1>
        <h2>Movie and Game Hub for enjoying life more ...</h2>
      </div>
      <p>
        <span>
          Create by <a href="#">Junio Akarda</a> with{" "}
        </span>
        <HeartTwoTone twoToneColor="#eb2f96" />
      </p>
      <Carousel autoplay style={{ height: "70vh",marginTop:"5vh" }}>
        <div className="bg">
         <img src={bg2} alt="bg2"/>
        </div>
        <div className="bg">
        <img src={bg1} alt="bg1"/>

        </div>
      </Carousel>

      <div className="hub">
        <h3>Movies</h3>
        {movieList ? (
          <Slider>
            {movieList.map((movie) => (
              <Slider.Item movie={movie} key={movie.id}>
                item1
              </Slider.Item>
            ))}
          </Slider>
        ) : (
          ""
        )}
        <Link to="/movie_list" className="btn draw-border">
          View All Movies
        </Link>
      </div>
      <div className="hub">
        <h3 style={{ color: "#e6739f" }}>Games</h3>
        {gameList ? (
          <Slider>
            {gameList.map((games) => (
              <Slider.Item movie={games} key={games.id}>
                item1
              </Slider.Item>
            ))}
          </Slider>
        ) : (
          ""
        )}
        <Link to="/game_list" className="btn draw-game">
          View All Games
        </Link>
      </div>
    </div>
  );
};

export default Home;
